import React from 'react';
import { Toaster } from 'react-hot-toast';

const baseStyle = {
  color: '#fff',
  fontFamily: "'DM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  fontSize: '15px',
  fontWeight: 500,
  padding: '12px 16px',
  minHeight: '48px',
  borderRadius: '10px',
  boxShadow: '0 8px 24px rgba(0, 0, 0, 0.35)',
  maxWidth: '420px',
  width: '90vw',
};

const isMobile =
  typeof window !== 'undefined' && window.matchMedia('(max-width: 1000px)').matches;

const ToasterCustom = () => {
  return (
    <Toaster
      position="bottom-center"
      gutter={10}
      containerStyle={{
        bottom: isMobile ? 170 : 24,
        zIndex: 250,
      }}
      toastOptions={{
        duration: 3500,
        style: {
          ...baseStyle,
          background: '#202326E0',
        },
        success: {
          iconTheme: { primary: '#fff', secondary: '#88B844' },
          style: { ...baseStyle, background: '#88B844E0' },
        },
        error: {
          iconTheme: { primary: '#fff', secondary: '#F26C66' },
          style: { ...baseStyle, background: '#F26C66E0' },
        },
        loading: {
          style: { ...baseStyle, background: '#202326E0' },
        },
      }}
    />
  );
};

export default ToasterCustom;
